module.exports = __webpack_public_path__ + "static/media/Project1_Fig5.aaab2c43.png";